import { render, staticRenderFns } from "./ResearchArticles.vue?vue&type=template&id=428e43f2"
import script from "./ResearchArticles.vue?vue&type=script&lang=js"
export * from "./ResearchArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports